import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useState } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';

import { InspectionFilesEdited, InspectionFilesGrouped } from '../../models/models';
import { getFileOrder } from '../../utilities/utilityFunctions';
import Thumbnail from '../Thumbnails';
import useStyles from './InspectionFilesView.styles';

interface Props {
  arrayList: InspectionFilesGrouped;
  titleKey: string;
  isEditable: boolean;
}
const InspectionFilesView: React.FC<Props> = ({ arrayList, titleKey, isEditable }) => {
  const classes = useStyles();
  const [isDragDisable, setIsDragDisable] = useState(false);

  const setDragDisable = useCallback((value: boolean) => {
    setIsDragDisable(value);
  }, []);

  const checkShowOnReport = () => {
    let countOfShowOnReportFiles = 0;
    if (arrayList?.true?.length) {
      countOfShowOnReportFiles += arrayList?.true.length;
    }
    return countOfShowOnReportFiles >= 2;
  };

  return (
    <Grid className={classes.filesContainer}>
      <div className={classes.droppleContainer}>
        <Droppable droppableId="false">
          {provided => (
            <div
              ref={provided.innerRef}
              className={classes.droppableFile}
              {...provided.droppableProps}
            >
              <p className={classes.text}>Not Shown On Report</p>
              <div className={classes.visibilityFile}>
                {arrayList &&
                  arrayList.false
                    ?.sort((a, b) => {
                      if (a.fileSortOrder !== undefined && b.fileSortOrder !== undefined) {
                        return a.fileSortOrder - b.fileSortOrder;
                      } else {
                        return 0;
                      }
                    })
                    .map((item: InspectionFilesEdited, index: number) => {
                      if (true) {
                        return (
                          <Draggable
                            key={item.fileUUID}
                            draggableId={`${item.fileUUID}^${titleKey}`}
                            index={index}
                            isDragDisabled={isEditable ? isDragDisable : true}
                          >
                            {provide => (
                              <div
                                className={classes.imageWidth}
                                ref={provide.innerRef}
                                {...provide.draggableProps}
                                {...provide.dragHandleProps}
                              >
                                <Thumbnail
                                  fileData={item}
                                  fileList={[] as InspectionFilesEdited[]}
                                  index={index}
                                  isShowOnReport={checkShowOnReport()}
                                  updateFileList={() => {}}
                                  arrayListLength={getFileOrder(arrayList?.false)}
                                  setDragDisable={setDragDisable}
                                  isEditable={isEditable}
                                />
                              </div>
                            )}
                          </Draggable>
                        );
                      }
                    })}
                {provided.placeholder}
              </div>
            </div>
          )}
        </Droppable>
      </div>
      <div className={classes.droppleContainer}>
        <Droppable droppableId="true">
          {provided => (
            <div
              ref={provided.innerRef}
              className={classes.droppableFile}
              {...provided.droppableProps}
            >
              <p className={classes.text}>Shown On Report</p>
              <div className={classes.visibilityFile}>
                {arrayList &&
                  arrayList.true
                    ?.sort((a, b) => {
                      if (a.fileSortOrder !== undefined && b.fileSortOrder !== undefined) {
                        return a.fileSortOrder - b.fileSortOrder;
                      } else {
                        return 0;
                      }
                    })
                    .map((item: InspectionFilesEdited, index) => {
                      if (true) {
                        return (
                          <Draggable
                            key={item.fileUUID}
                            draggableId={`${item.fileUUID}^${titleKey}`}
                            index={index}
                            isDragDisabled={isEditable ? isDragDisable : true}
                          >
                            {providedData => (
                              <div
                                className={classes.imageWidth}
                                ref={providedData.innerRef}
                                {...providedData.draggableProps}
                                {...providedData.dragHandleProps}
                              >
                                <Thumbnail
                                  fileData={item}
                                  fileList={[] as InspectionFilesEdited[]}
                                  index={index}
                                  isShowOnReport={checkShowOnReport()}
                                  updateFileList={() => {}}
                                  arrayListLength={getFileOrder(arrayList?.false || [])}
                                  setDragDisable={setDragDisable}
                                  isEditable={isEditable}
                                />
                              </div>
                            )}
                          </Draggable>
                        );
                      }
                    })}
                {provided.placeholder}
              </div>
            </div>
          )}
        </Droppable>
      </div>
    </Grid>
  );
};
export default observer(InspectionFilesView);
